import React, { ReactElement } from "react";
import Head from "next/head";
import ReadyToMoveBanner from "@/components/landing-new/ReadyToMoveBanner";
import getConfig from "next/config";
import { MainLayout } from "@/containers/layout/NowLayout";
import { getAllStoredUTMParams } from "@/shared/hooks/useUTMTracker";

const { publicRuntimeConfig } = getConfig();

const UploadBankStatements = (): JSX.Element => {
  return (
    <>
      <Head>
        <title>Verify your income to get approved by Keyzy</title>
        <link rel="canonical" href="https://www.keyzy.com/apply/upload-bank-statements" />
        <meta
          name="description" key="description"
          content="Upload recent bank statements so we can confirm your income as part of your Keyzy application for a rent-to-own home. We accept CSV, XLS and PDF format."
        />
        <meta
          name="twitter:card"
          content="Upload recent bank statements so we can confirm your income as part of your Keyzy application for a rent-to-own home. We accept CSV, XLS and PDF format."
          key="twcard"
        />
        <meta name="twitter:creator" content="keyzyhomes" key="twhandle" />
        <meta property="og:url" content="/" key="ogurl" />
        <meta property="og:image" content="/now/meta-og-keyzy-now.png" key="ogimage" />
        <meta property="og:image:width" content="1200" />
        <meta property="og:image:height" content="630" />
        <meta property="og:site_name" content="Keyzy" key="ogsitename" />
        <meta
          property="og:title"
          content="Upload recent bank statements so we can confirm your income as part of your Keyzy application for a rent-to-own home. We accept CSV, XLS and PDF format."
          key="ogtitle"
        />
        <meta property="og:type" content="website" />
        <meta property="og:locale" content="en_GB" />
        <meta
          property="og:description"
          content="Upload recent bank statements so we can confirm your income as part of your Keyzy application for a rent-to-own home. We accept CSV, XLS and PDF format."
          key="ogdesc"
        />
      </Head>
      <div className="bg-white min-h-[600]">
        <iframe
          key="1"
          src={`${
            publicRuntimeConfig.NEXT_TYPEFORM_UPLOAD_BANK_STATEMENTS_URL
          }#${getAllStoredUTMParams()}}`}
          style={{ height: "700px", width: "100%" }}
        />
      </div>
      <div className="bg-white">
        <ReadyToMoveBanner />
      </div>
    </>
  );
};

UploadBankStatements.getLayout = function getLayout(page: ReactElement) {
  return (
    <>
      <MainLayout theme="dark">{page}</MainLayout>
    </>
  );
};

export default UploadBankStatements;
